import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {NotRatedOptionReasonModel} from '@/libs/Api';
import {NotRatedOptionReasonsDataService} from '@/libs/not-rated-option-reasons/not-rated-option-reasons-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const notRatedOptionReasonsStore = registerCrudStore<NotRatedOptionReasonModel, NotRatedOptionReasonModel>(BusinessModule.NotRatedOptionReason, new NotRatedOptionReasonsDataService());
